// extracted by mini-css-extract-plugin
export var container = "ExpandingCardSet-module--container--b7c04";
export var expandButton = "ExpandingCardSet-module--expandButton--ae6a7";
export var expanded = "ExpandingCardSet-module--expanded--6d4a4";
export var overlay = "ExpandingCardSet-module--overlay--e3c00";
export var title = "ExpandingCardSet-module--title--f7ba8";